import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Initialize state from localStorage
  const [authToken, setAuthTokenState] = useState(() => localStorage.getItem('authToken') || null);
  const [selectedShopCode, setSelectedShopCodeState] = useState(() => localStorage.getItem('selectedShopCode') || '');

  // Update localStorage whenever authToken changes
  useEffect(() => {
    if (authToken) {
      localStorage.setItem('authToken', authToken);
    } else {
      localStorage.removeItem('authToken');
    }
  }, [authToken]);

  // Update localStorage whenever selectedShopCode changes
  useEffect(() => {
    if (selectedShopCode) {
      localStorage.setItem('selectedShopCode', selectedShopCode);
    } else {
      localStorage.removeItem('selectedShopCode');
    }
  }, [selectedShopCode]);

  // Wrapper functions to update both state and localStorage
  const setAuthToken = (token) => {
    setAuthTokenState(token);
  };

  const setSelectedShopCode = (shopCode) => {
    setSelectedShopCodeState(shopCode);
  };

  const value = {
    authToken,
    setAuthToken,
    selectedShopCode,
    setSelectedShopCode,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export { AuthContext, useAuth };